import { render } from "./BopSummary.vue?vue&type=template&id=0775c472&scoped=true"
import script from "./BopSummary.vue?vue&type=script&lang=js"
export * from "./BopSummary.vue?vue&type=script&lang=js"

import "./BopSummary.vue?vue&type=style&index=0&id=0775c472&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0775c472"]])

export default __exports__